module.exports = __webpack_public_path__ + "img/chile.174eee37.svg";